/* eslint-disable import/no-anonymous-default-export */
import Flexbox from './flexbox/Flexbox';
import MainLayout from './layout/MainLayout';

export default { Flexbox, MainLayout };
